import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconComponent } from '../../../../../shared/components/icon/icon.component';
import { IconType } from '../../../../../shared/services/icon.service';

@Component({
  selector: 'app-activity-card',
  standalone: true,
  imports: [CommonModule, IconComponent],
  templateUrl: './activity-card.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './activity-card.component.css',
})
export class ActivityCardComponent {
  @Input() title = '';
  @Input() count = 0;
  @Input() subtitle = '';
  @Input() icon: IconType = IconType.CALENDAR;
  @Input() accentColor: 'blue' | 'green' | 'purple' | 'orange' = 'blue';
  @Input() actionLabel = 'Anzeigen';
  @Input() loading = false;
  @Input() emptyMessage = 'Keine Einträge';
  @Output() action = new EventEmitter<void>();

  readonly IconType = IconType;

  onAction(): void {
    this.action.emit();
  }

  getAccentClass(): string {
    return `accent-${this.accentColor}`;
  }
}
